/* @flow */
import * as React from 'react';

import BirthdateModalSection from 'chat/components/BirthdateModalSection';
import Input from 'components/Input';
import Label from 'components/Label';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';

class AskForParentEmail extends React.Component<{}, *> {
  state = {
    parentEmail: '',
  };

  onSubmit = () => {
    UserActions.setParentEmail(this.state.parentEmail).catch(() => {
      ToastActions.showErrorToast('Invalid parent email. Please try again.');
    });
  };

  buttonDisabled = () => {
    return false;
  };

  handleParentEmailInputChange = ({ target }: SyntheticInputEvent<>) => {
    this.setState({ parentEmail: target.value });
  };
  renderCollector = () => {
    return (
      <div>
        <Label htmlFor="">{'Parent’s email'}</Label>
        <Input
          type="text"
          value={this.state.parentEmail}
          onChange={this.handleParentEmailInputChange}
        />
      </div>
    );
  };
  render() {
    return (
      <BirthdateModalSection
        title="Please enter your parent’s email"
        subtext="In order to keep using Remind, we’ll need to notify a parent."
        renderCollector={this.renderCollector}
        buttonDisabled={this.buttonDisabled}
        onSubmit={this.onSubmit}
      />
    );
  }
}
export default AskForParentEmail;
